export enum IframeRedirectActions {
  PaymentsRedirect ='PaymentsRedirect',
}

export enum IframeStatusMessages {
  Success = 'SUCCESS',
  InvalidAction = 'INVALID_ACTION',
}

export const AUTH_UI_MESSAGE = 'AUTH_UI_MESSAGE';
export const AUTH_UI_RESPONSE = 'AUTH_UI_RESPONSE';
